import { connect } from 'react-redux';
import { CourseCard } from './component';
import { getActionForUrl } from '../../../utilities/reduxLinks';
import { makeMetricsLogEvent } from '../../../../ReduxStorage/Metrics/manualEventDispatchers';

export const ConnectedCourseCard = connect(
  (state, ownProps) => ({
    to: getActionForUrl(`${ownProps.courseUrl}/`),
  }),
  (dispatch) => ({
    metricsLogEvent: (eventName, interactionData, immediate, options) =>
      dispatch(
        makeMetricsLogEvent(eventName, interactionData, immediate, options)
      ),
  })
)(CourseCard);
